<template>
  <div>

    <main role="main">

      <div class="container">

        <div class="row">

          <div class="col-md-12">

            <h2 class="mb-3">
              MQ testni klient

              <a class="btn btn-danger text-white float-right" @click.stop="clearNodeChanges">Počisti</a>
            </h2>

          </div>
        </div>

        <div class="row">
          <div class="col-md-12">


            <em class="table" v-if="!nodeChanges">
              Ni sprememb.
            </em>
            <table class="table" v-if="nodeChanges && nodeChanges.length > 0">
              <thead>
              <tr>
                <th>#</th>
                <th>Node Ref</th>
                <th>Event type</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in nodeChanges" :key="'item_' + index">
                <td>
                  {{index+1}}
                </td>
                <td>
                  {{item.split(',')[0].split(':')[1]}}
                </td>
                <td>
                  {{item.split(',')[1].split(':')[1]}}
                </td>
              </tr>
              </tbody>
            </table>

          </div>
        </div>

      </div>

    </main>

  </div>
</template>

<script type="text/javascript">
import Vue from 'vue';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import AudiLogRegisterTable from "../components/AudiLogRegisterTable";

export default {
  name: 'AuditLogExternal',
  components: {
    Loading,
    vSelect,
    AudiLogRegisterTable,
  },

  data() {
    return {
      nodeChanges: null,
      isLoading: false,
    };
  },

  computed: {},

  mounted() {
    const _this = this;

    _this.getNodeChanges();

  },

  methods: {
    getNodeChanges() {
      const _this = this;

      _this.isLoading = true;

      axios.get(config.nodeChanges)
          .then((res) => {

            console.log("res", res);
            //_this.nodeChanges = res.data.body ? JSON.parse(res.data.body) : null;
            let response = res.data.body;
            response = response.replace(/[\"]+/g, '');
            console.log("response", response);
            response = response.replace(/}{/g, '[n]');
            console.log("response", response);
            response = response.replace(/[{]+/g, '');
            response = response.replace(/[}]+/g, '');
            console.log("response", response);
            _this.nodeChanges = response ? response.split('[n]') : null;
            console.log("_this.nodeChanges", _this.nodeChanges);

          })
          .catch((error) => {
            console.error(error);
          });
    },


    clearNodeChanges() {
      const _this = this;

      _this.isLoading = true;

      axios.post(config.clearNodeChanges)
          .then((res) => {

            _this.getNodeChanges();

          })
          .catch((error) => {
            console.error(error);
          });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/MQtestClient.vue